@if (!(loadingFavorites$|async)) {
  @if (!favoritesPage) {
    @if (isUserAuthenticated && productId && !(favoritesIds$|async)?.includes(productId)) {
      <button class="btn btn-link" (click)="addFavorite()">
        <i class="sli-star"></i> <span>{{'Add to my Favorites'|translate}}</span>
      </button>
    }
    @if (isUserAuthenticated && productId && (favoritesIds$|async)?.includes(productId)) {
      <button class="btn added" (click)="removeFavorite()">
        <i class="sli-like"></i> <span>{{'Added to favorites list'|translate}}</span>
      </button>
    }
  } @else {
    <div class="flex-end mb-2">
      <i (click)="removeFavorite()" class="material-icons remove-btn"
      title="{{'Remove'|translate}}">close</i>
    </div>
  }
}
